import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSettingsStore } from "../store/settings";
import { useGameStore } from "../store/game";

const LANG_LABEL: Record<string, string> = { en: "English", tr: "Türkçe", de: "Deutsch" };

const MENU = [
  { to: "/play", label: "play" },
  { to: "/stats", label: "stats" },
  { to: "/settings", label: "settings" },
];

export function Home() {
  const settings = useSettingsStore((s) => s.settings);
  const status = useGameStore((s) => s.status);
  const hasActiveRound = status === "resuming" || status === "playing";

  return (
    <div className="min-h-[78vh] flex flex-col items-center justify-center">
      <motion.h1
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="font-display text-7xl sm:text-8xl tracking-tight mb-12"
      >
        <span
          className="bg-clip-text text-transparent"
          style={{ backgroundImage: "linear-gradient(135deg,#a78bfa,#38bdf8,#fbbf24)" }}
        >
          embethat
        </span>
      </motion.h1>

      <ul className="flex flex-col items-stretch w-full max-w-sm">
        {MENU.map((item, i) => (
          <motion.li
            key={item.to}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: 0.08 + i * 0.06 }}
          >
            <MenuLink
              to={item.to}
              label={item.label}
              badge={item.to === "/play" && hasActiveRound ? "resume" : undefined}
            />
          </motion.li>
        ))}
      </ul>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mt-12 text-xs text-ink-400 flex gap-3 flex-wrap justify-center"
      >
        <span>{LANG_LABEL[settings.language] ?? settings.language}</span>
        <span className="text-ink-600">·</span>
        <span>{settings.targetType}</span>
        <span className="text-ink-600">·</span>
        <span>
          {settings.mode === "classic" ? "classic" : `time-attack ${settings.timeLimitSeconds}s`}
        </span>
      </motion.div>
    </div>
  );
}

function MenuLink({ to, label, badge }: { to: string; label: string; badge?: string }) {
  return (
    <Link to={to} className="group block">
      <div className="flex items-baseline gap-3 py-3.5 border-b border-white/5 group-hover:border-white/20 transition-colors">
        <span className="font-display text-3xl text-ink-200 group-hover:text-ink-100 transition-colors">
          {label}
        </span>
        {badge && (
          <span className="text-[10px] uppercase tracking-[0.2em] px-2 py-0.5 rounded-full bg-accent/20 text-accent">
            {badge}
          </span>
        )}
        <motion.span
          className="ml-auto text-ink-400 group-hover:text-accent transition-colors text-2xl"
          initial={false}
          whileHover={{ x: 4 }}
        >
          →
        </motion.span>
      </div>
    </Link>
  );
}
